import type { FocusCohort } from "./patterns.api";

const UMBRELLA_PATTERNS = new Set(["mistake", "blunder", "imprecision"]);

export const specificPatternStats = <T extends { motif: string; gameCount: number }>(patterns: readonly T[]): T[] =>
  patterns.filter(({ motif, gameCount }) => !UMBRELLA_PATTERNS.has(motif) && gameCount >= 2);

export const patternEvidenceLabels = ({
  cohort,
  analyzedGames,
  occurrences,
  affectedGames,
  distinctDates,
  maxGames,
  maxAgeDays,
}: {
  cohort: FocusCohort;
  analyzedGames: number;
  occurrences: number;
  affectedGames: number;
  distinctDates: number;
  maxGames: number;
  maxAgeDays: number;
}) => [
  { kind: "verified" as const, text: `${occurrences} verified occurrences` },
  {
    kind: "source" as const,
    text: `${affectedGames} of ${analyzedGames} ${cohort[0].toUpperCase()}${cohort.slice(1)} games · ${distinctDates > 0 ? `${distinctDates} distinct dates` : "dates unavailable"}`,
  },
  { kind: "window" as const, text: `Newest ${maxGames} · last ${maxAgeDays} days` },
];

export const focusTechnicalEffect = (cohort: FocusCohort): string =>
  `Focus watches one decision cue in later ${cohort[0].toUpperCase()}${cohort.slice(1)} games. It changes what Chessla brings to your attention—not legal moves, engine evaluations, or Pattern evidence.`;

export const patternExamplePly = (ply: number | undefined): number | null =>
  Number.isInteger(ply) && (ply ?? 0) > 0 ? ply! : null;
